<template>
  <pt-active-sign class="pt-active-sign__page"></pt-active-sign>
</template>

<script>
import PtActiveSign from 'cps/appointment-application/pt-active-sign/withData'
export default {
  name: 'pt-active-sign__view',
  components: {
    'pt-active-sign': PtActiveSign
  }
}
</script>
